import { Accordion as BaseUiAccordion } from '@base-ui-components/react/accordion';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '#/ui/utils/types';

export interface AccordionProps extends React.PropsWithChildren<CommonProps> {
  /**
   * The size of the accordion.
   * @default "medium"
   */
  size?: 'small' | 'medium' | 'large';
  /**
   * The variant of the accordion.
   * @default "rounded"
   */
  variant?: 'border' | 'flat';
}

function Accordion({ children, className, size = 'medium', variant = 'border' }: AccordionProps) {
  return (
    <BaseUiAccordion.Root
      className={twMerge(
        'gooey-accordion',
        'flex w-full flex-col justify-center',
        variant === 'border' &&
          '[&_.gooey-accordion-item]:border-x [&_.gooey-accordion-item:first-of-type]:border-t [&_.gooey-accordion-summary]:px-2 [&_.gooey-accordion-details]:px-2 [&_.gooey-accordion-item:first-of-type]:rounded-t-xl [&_.gooey-accordion-item:last-of-type]:rounded-b-xl',
        size === 'small' &&
          '[&_.gooey-accordion-summary]:text-sm [&_.gooey-accordion-details]:text-xs [&_.gooey-accordion-icon]:size-3',
        size === 'medium' &&
          '[&_.gooey-accordion-summary]:text-lg [&_.gooey-accordion-details]:text-base [&_.gooey-accordion-icon]:size-4',
        size === 'large' &&
          '[&_.gooey-accordion-summary]:text-xl [&_.gooey-accordion-details]:text-lg [&_.gooey-accordion-icon]:size-5',
        className
      )}
    >
      {children}
    </BaseUiAccordion.Root>
  );
}
Accordion.display = 'GooeyAccordion';

export default Accordion;
